"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.multiBindToService = function (container) {
  return function (service) {
    return function () {
      var types = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        types[_i] = arguments[_i];
      }
      return types.forEach(function (t) {
        return container.bind(t).toService(service);
      });
    };
  };
};